import {Box, Typography} from "@material-ui/core";
import Avatar from "@material-ui/core/Avatar";
import React from "react";
import {useTranslate} from "@tolgee/react";
import useStyles from "./styles";

type TopBarProps = {
  showLogoUrl?: string;
  title?: string;
  organiserLogoUrl?: string;
};

const TopBar: React.FC<TopBarProps> = ({
  title,
  showLogoUrl,
  organiserLogoUrl,
}) => {
  const classes = useStyles();
  const {t} = useTranslate();
  const organiser = t("exhibitor_dashboard.show_card.organiser");

  return (
    <Box className={classes.root}>
      <Box className={classes.barContainer}>
        <Box className={classes.show}>
          <Avatar
            className={classes.showLogo}
            variant="square"
            src={showLogoUrl}
          >
            {title?.charAt(0)}
          </Avatar>
          <Typography variant="h3" component="h2" className={classes.text}>
            {title}
          </Typography>
        </Box>
        <Box className={classes.avatar}>
          <Typography variant="h3" component="h2" className={classes.text}>
            {organiser}
          </Typography>
          <Avatar
            alt={organiser}
            className={classes.organiserLogo}
            variant="square"
            src={organiserLogoUrl}
          >
            O
          </Avatar>
        </Box>
      </Box>
    </Box>
  );
};
export default TopBar;
